export const EXPAND_ADDRESS = 'EXPAND_ADDRESS';
export const FAST_COLLAPSE_ADDRESS = 'COLLAPSE_ADDRESS';
export const SLOW_COLLAPSE_ADDRESS = 'SLOW_COLLAPSE_ADDRESS';

export const ADDRESS_EXPANDED = 'expanded';
export const ADDRESS_COLLAPSED = 'collapsed';
export const ADDRESS_COLLAPSING = 'collapsing';

// these two values are related, don't change one without re-adjusting the other
export const ADDRESS_ANIMATION_TIME = 500;
export const FOCUS_TO_ELEMENT_WAIT_TIME = 100;
